export default __webpack_public_path__ + "static/media/MOFSL-Post-Log-In-financial-services-370X120.a268e41c.jpg";